import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTimezonePipe } from './custom-timezone.pipe';
import { PayrollDisplayPipe } from './payroll-display.pipe';
import { SentenceCasePipe } from './sentence-case.pipe';



@NgModule({
  declarations: [CustomTimezonePipe, PayrollDisplayPipe, SentenceCasePipe],
  imports: [
    CommonModule
  ],
  exports: [
    CustomTimezonePipe,
    PayrollDisplayPipe,
    SentenceCasePipe
  ]
})
export class PipesModule { }
